import { FormControl, Validators } from '@angular/forms';
import { EoDatepickerConfig, EoFormPanelConfig } from 'ngx-eo-web-components';

const currentDate = new Date();
const dateNow = createDateNowUtc();

export const surgeryScheduleFormPanel = new EoFormPanelConfig({
  name: 'surgeryScheduleForm',
  panelContentStyleClass: 'grid',
  config: [
    new EoDatepickerConfig({
      styleClass: 'col-12',
      label: 'Ημερομηνία Χειρουργείου',
      name: 'surgeryDateTime',
      control: new FormControl('', [Validators.required]),
      appendTo: 'body',
      //minDate: dateNow, ::ToDo: Uncomment when minDate is implemented
      placeholder: 'Παρακαλώ επιλέξτε ημερομηνία'
    }),
  ],
});

export const surgeryScheduleFormConfig: EoFormPanelConfig[] = [
  surgeryScheduleFormPanel,
];

const setFc = (formGroupName: string, formControlName: string, value: any) => {
  surgeryScheduleFormConfig
    .find((sfc) => sfc.name === formGroupName)
    ?.config?.find((c) => c.name === formControlName)
    ?.control?.setValue(value);
};

function createDateNowUtc() {
  return new Date(
    Date.UTC(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate()
    )
  );
}

export const initDatePicker = (): void => {
  setFc('surgeryScheduleForm', 'surgeryDateTime', dateNow);
};
